"use strict";
/**
 * We can't be smarter on this file both due to the static nature
 * of both Webpack's env variable replacement and ES6 module syntax.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN_JSDOM_ENV = void 0;
/* eslint-disable padding-line-between-statements, no-process-env, no-console */
// prettier-ignore
const initial = {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_STATIC_BACKEND_API_HOST: process.env.NEXT_STATIC_BACKEND_API_HOST,
    NEXT_STATIC_SHARED_FILE_RESOLVER_HOST: process.env.NEXT_STATIC_SHARED_FILE_RESOLVER_HOST,
    NEXT_STATIC_CAPITAL_ENV: process.env.NEXT_STATIC_CAPITAL_ENV,
    NEXT_STATIC_HEAP_ID: process.env.NEXT_STATIC_HEAP_ID,
    NEXT_STATIC_SEGMENT_ID: process.env.NEXT_STATIC_SEGMENT_ID,
    NEXT_STATIC_GOOGLE_ANALYTICS_ID: process.env.NEXT_STATIC_GOOGLE_ANALYTICS_ID,
    FINCH_CLIENT_ID: process.env.FINCH_CLIENT_ID,
    FINCH_REDIRECT_URI: process.env.FINCH_REDIRECT_URI,
    FLAGSMITH_CLIENT_SIDE_ENVIRONMENT_KEY: process.env.FLAGSMITH_CLIENT_SIDE_ENVIRONMENT_KEY,
    FLAGSMITH_API_URL: process.env.FLAGSMITH_API_URL,
    NEXT_STATIC_GOOGLE_TM_ID: process.env.NEXT_STATIC_GOOGLE_TM_ID,
    NEXT_STATIC_PLAID_CLIENT_ID: process.env.NEXT_STATIC_PLAID_CLIENT_ID,
    NEXT_STATIC_PLAID_PUBLIC_KEY: process.env.NEXT_STATIC_PLAID_PUBLIC_KEY,
    NEXT_STATIC_QUICKBOOKS_CLIENT_ID: process.env.NEXT_STATIC_QUICKBOOKS_CLIENT_ID,
    NEXT_STATIC_STRIPE_CLIENT_ID: process.env.NEXT_STATIC_STRIPE_CLIENT_ID,
    NEXT_STATIC_FRESHBOOKS_CLIENT_ID: process.env.NEXT_STATIC_FRESHBOOKS_CLIENT_ID,
    NEXT_STATIC_FRESHBOOKS_REDIRECT_URI: process.env.NEXT_STATIC_FRESHBOOKS_REDIRECT_URI,
    NEXT_STATIC_RELEASE: process.env.NEXT_STATIC_RELEASE,
    NEXT_STATIC_SHOPIFY_CLIENT_ID: process.env.NEXT_STATIC_SHOPIFY_CLIENT_ID,
    NEXT_STATIC_PAYPAL_CLIENT_ID: process.env.NEXT_STATIC_PAYPAL_CLIENT_ID,
    NEXT_STATIC_PAYPAL_API_URL: process.env.NEXT_STATIC_PAYPAL_API_URL,
    NEXT_STATIC_XERO_CLIENT_ID: process.env.NEXT_STATIC_XERO_CLIENT_ID,
    NEXT_STATIC_SQUARE_CLIENT_ID: process.env.NEXT_STATIC_SQUARE_CLIENT_ID,
    NEXT_STATIC_SQUARE_DOMAIN: process.env.NEXT_STATIC_SQUARE_DOMAIN,
    NEXT_STATIC_SQUARE_AUTHZ_URL: process.env.NEXT_STATIC_SQUARE_AUTHZ_URL,
    CAPITAL_DOMAIN: process.env.CAPITAL_DOMAIN,
    CAPITAL_MAIN_DOMAIN: process.env.CAPITAL_MAIN_DOMAIN,
    DATA_DOG_APPLICATION_ID: process.env.DATA_DOG_APPLICATION_ID,
    DATA_DOG_CLIENT_TOKEN: process.env.DATA_DOG_CLIENT_TOKEN,
    V2_BASE_URL: process.env.V2_BASE_URL,
    API_GATEWAY_URL: process.env.API_GATEWAY_URL,
    AUTH0_DOMAIN: process.env.AUTH0_DOMAIN,
    AUTH0_CLIENT_ID: process.env.AUTH0_CLIENT_ID,
    AUTH0_LOGIN_REDIRECT_URI: process.env.AUTH0_LOGIN_REDIRECT_URI,
    AUTH0_AUDIENCE: process.env.AUTH0_AUDIENCE,
};
let overrides = {};
try {
    overrides = JSON.parse(localStorage.getItem('process.env') || '{}');
}
catch (_a) {
    console.warn('You have a syntax error in the `process.env` localStorage item. It must be a stringified object.');
}
const env = {};
for (const name in initial) {
    if (initial.hasOwnProperty(name)) {
        env[name] =
            typeof overrides[name] !== 'undefined' ? overrides[name] : initial[name];
    }
}
exports.IN_JSDOM_ENV = navigator.userAgent.includes('Node.js') ||
    navigator.userAgent.includes('jsdom');
exports.default = env;
//# sourceMappingURL=env.js.map